/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { scroller } from "react-scroll";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import RodoContent from '../../components/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import Select from 'react-select';
import loadingData from './loading';
import agentConfig from './agent';

import v from './validators';

const {
  errorSpanStyle,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const wlascicielDict = {
  Name: {
    label: 'Oznaczenie przedsiębiorcy (Imię nazwisko / nazwa)',
    editable: true,
    type: 'textarea',
  },
  Address: {
    label: 'Siedziba przedsiębiorcy (siedziba i adres, w przypadku osób fizycznych w tym wspólników spółki cywilnej - adresy zamieszkania)',
    editable: true,
    type: 'textarea',
  },
};

const wlascicielDictHrubieszow = {
  Name: {
    label: 'Oznaczenie przedsiębiorcy (imię i nazwisko, firma lub nazwa przedsiębiorcy ze wskazaniem formy prawnej)',
    editable: true,
    type: 'textarea',
  },
  Address: {
    label: 'Siedziba i adres przedsiębiorcy',
    editable: true,
    type: 'textarea',
  },
};

const daneWlascicielDict = {
  dane: {
    label: 'Numer w rejestrze przedsiębiorców KRS o ile przedsiębiorca taki numer posiada, oraz numer identyfikacji podatkowej NIP',
    editable: true,
    type: 'textarea',
  },
};

const pelnomocnikDict = {
  pelnomocnik: {
    label: 'Pełnomocnicy w przypadku ich ustanowienia (imię i nazwisko, adres zamieszkania)',
    editable: true,
    type: 'textarea',
  },
};

const sprzedazDict = {
  AddressSprzedaz: {
    label: 'Adres punktu sprzedaży',
    editable: true,
    type: 'textarea',
  },
};

const skladowanieDict = {
  AddressSkladowanie: {
    label: 'Adres punktu składowania napojów alkoholowych (magazynu dystrybucyjnego)',
    editable: true,
    type: 'textarea',
  },
};

const contactDict = {
  contactPhone: {
    label: 'Telefony kontaktowe',
    editable: true,
  },
};

const options = [
  {
    label: 'WNIOSEK NA WYDANIE ZEZWOLENIA NA SPRZEDAŻ NAPOJÓW ALKOHOLOWYCH DLA PRZEDSIĘBIORCÓW, KTÓRYCH DZIAŁALNOŚĆ POLEGA NA ORGANIZACJI PRZYJĘĆ',
    value: 'impreza',
    target: {
      name: 'type',
      value: 'impreza',
    },
  },
  {
    label: 'WNIOSEK NA WYDANIE ZEZWOLENIA NA SPRZEDAŻ NAPOJÓW ALKOHOLOWYCH',
    value: 'sklep',
    target: {
      name: 'type',
      value: 'sklep',
    },
  },
];

const optionsPrzedmiot = [
  {
    label: 'Detal - sprzedaż napojów alkoholowych przeznaczonych do spożycia poza miejscem sprzedaży',
    value: 'detal',
    target: {
      name: 'przedmiot',
      value: 'detal',
    },
  },
  {
    label: 'Gastronomia - sprzedaż i podawanie napojów alkoholowych przeznaczonych do spożycia w miejscu sprzedaży',
    value: 'gastronomia',
    target: {
      name: 'przedmiot',
      value: 'gastronomia',
    },
  },
];

class ZezwolenieAlkohol extends React.Component {
  state = {
    info: {
      agentAdd: 'NIE',
    },
    wlasciciel: {
      Name: null,
      Address: null,
    },
    pelnomocnik: {
      pelnomocnik: null,
    },
    AddressSprzedaz: {
      AddressSprzedaz: null,
    },
    AddressSkladowanie: {
      AddressSkladowanie: null,
    },
    danePrzedsiebiorcy: {
      dane: null,
    },
    contact: {
      contactPhone: null,
    },
    alkohol: {
      piwo: false,
      wino: false,
      wodka: false,
      type: null,
      przedmiot: '',
      punkt: '',
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    loading: false,
    eserviceDistrict: null,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    Name: [v.NotNull],
    Address: [v.NotNull],
    AddressSprzedaz: [v.NotNull],
    AddressSkladowanie: [v.NotNull],
    dane: [v.NotNull, v.MinLength(5)],
    AddressStreet2: [v.NotNull],
    AddressFlat2: [v.NotNull],
    AddressNumber2: [v.NotNull],
    AddressZipCode2: [v.NotNull],
    AddressCity3: [v.NotNull, v.MinLength(2)],
    AddressStreet3: [v.NotNull],
    AddressFlat3: [v.NotNull],
    AddressNumber3: [v.NotNull],
    AddressZipCode3: [v.NotNull],
    AddressCity4: [v.NotNull, v.MinLength(2)],
    AddressStreet4: [v.NotNull],
    AddressFlat4: [v.NotNull],
    AddressNumber4: [v.NotNull],
    AddressZipCode4: [v.NotNull],
    przeznaczenie: [v.NotNull],
    uzasadnienie: [v.NotNull],
    type: [v.NotSelected],
    przedmiot: [v.NotSelected],
    pelnomocnik: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount = () => {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    if (this.props.prefix === 'hrubieszow') {
      this.validators.type = [];
      this.setState({
        alkohol: {
          ...this.state.alkohol,
          type: 'sklep',
        } });
    }
  };

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>y
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  onChange = (e, group) => {
    const name = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    if (name === 'type' && value === 'impreza') {
      this.resetData();
    }
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: value,
        },
      },
      () => this.validate(group, name),
    );
  };

  resetData = () => {
    const alkohol = this.state.alkohol;
    alkohol.przedmiot = '';
    alkohol.punkt = '';

    this.setState({ alkohol });
  }

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name === 'agentAdd' && e.value === 'TAK') {
      this.validators.pelnomocnik = [v.NotNull];
    } else {
      this.validators.pelnomocnik = [];
    }
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  toggleCheckbox = (e, group, name) => {
    this.setState({
      [group]: {
        ...this.state[group],
        [name]: !this.state[group][name],
      },
    });
  };

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        let check;
        if (!(field === 'przedmiot' & this.state.alkohol.type === 'impreza')) {
          check = validator(this.state[group][field]);
        }
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['wlasciciel', 'pelnomocnik', 'AddressSprzedaz', 'AddressSkladowanie', 'alkohol', 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  scrollToSection = (field) => {
    scroller.scrollTo(field, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -400,
    });
  };

  insertTestData = () => {
    this.setState({
      wlasciciel: {
        Name: 'Piotr',
        Address: 'Wawa',
      },
      pelnomocnik: {
        pelnomocnik: 'Kowalski',
      },
      AddressSprzedaz: {
        AddressSprzedaz: 'KEN 43',
      },
      AddressSkladowanie: {
        AddressSkladowanie: 'KEN 85',
      },
      danePrzedsiebiorcy: {
        dane: 'Jan',
      },
      contact: {
        contactPhone: '123456789',
      },
      alkohol: {
        piwo: false,
        wino: false,
        wodka: true,
        type: 'sklep',
        przedmiot: 'gastronomia',
        punkt: 'dom',
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    // if (this.state.selectedParcels.length === 0) {
    //   this.setState({
    //     errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
    //     errorTitle: 'Błędnie wypełniony formularz',
    //     showError: true,
    //   });
    //   return;
    // }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const alko = this.state.alkohol;
    if (!alko.piwo && !alko.wino && !alko.wodka) {
      this.setState({
        errorText: 'W sekcji 7. należy wybrać co najmniej jeden rodzaj zezwolenia.',
        errorTitle: 'Nie wybrano rodzaju zezwolenia.',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('GrayPanel_7'));
      return;
    }

    if (this.state.alkohol.type === 'sklep' && (!this.state.attachments || this.state.attachments.length === 0)) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          wlasciciel: { ...this.state.wlasciciel },
          pelnomocnik: { ...this.state.pelnomocnik },
          sprzedaz: { ...this.state.AddressSprzedaz },
          danePrzedsiebiorcy: { ...this.state.danePrzedsiebiorcy },
          skladowanie: { ...this.state.AddressSkladowanie },
          contact: { ...this.state.contact },
          alkohol: { ...this.state.alkohol },
          info: this.state.info,
          dzialki: [],
          selectedParcels: [],
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />
        {this.props.prefix === 'hrubieszow' ?
          <DecisionContainer
            title={'2. Przedsiębiorca'}
            data={this.state.wlasciciel}
            errors={this.state.errors}
            formDict={wlascicielDictHrubieszow}
            onChange={e => this.onChange(e, 'wlasciciel')}
          /> :
          <DecisionContainer
            title={'2. Przedsiębiorca'}
            data={this.state.wlasciciel}
            errors={this.state.errors}
            formDict={wlascicielDict}
            onChange={e => this.onChange(e, 'wlasciciel')}
          />}

        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ color: 'red' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent && this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'3. Pełnomocnik'}
            data={this.state.pelnomocnik}
            errors={this.state.errors}
            formDict={pelnomocnikDict}
            onChange={e => this.onChange(e, 'pelnomocnik')}
          /> : null }

        {this.state.eserviceDistrict && !this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'3. Pełnomocnik'}
            data={this.state.pelnomocnik}
            errors={this.state.errors}
            formDict={pelnomocnikDict}
            onChange={e => this.onChange(e, 'pelnomocnik')}
          /> : null }

        <DecisionContainer
          title={'4. Dane przedsiębiorcy'}
          data={this.state.danePrzedsiebiorcy}
          errors={this.state.errors}
          formDict={daneWlascicielDict}
          onChange={e => this.onChange(e, 'danePrzedsiebiorcy')}
        />

        <DecisionContainer
          title={'5. Adres sprzedaży'}
          data={this.state.AddressSprzedaz}
          errors={this.state.errors}
          formDict={sprzedazDict}
          onChange={e => this.onChange(e, 'AddressSprzedaz')}
        />

        <DecisionContainer
          title={'6. Adres składowania'}
          data={this.state.AddressSkladowanie}
          errors={this.state.errors}
          formDict={skladowanieDict}
          onChange={e => this.onChange(e, 'AddressSkladowanie')}
        />

        <GrayPanel title={'7. Wybór zezwolenia'}>
          <div className="row mobile-row" style={rowStyle} id={'GrayPanel_7'}>
            <div className="col-sm-2" />
            <div className="col-sm-2">

              <input
                type="checkbox"
                name="piwo"
                className="form-control"
                onChange={e => this.toggleCheckbox(e, 'alkohol', 'piwo')}
                checked={this.state.alkohol.piwo}
              />
            </div>
            <div className="col-sm-6">
              <label htmlFor="niskoprocentowe" style={labelStyle}>do 4,5 % zawartości alkoholu oraz na piwo</label>
            </div>
            <div className="col-sm-2" />
          </div>

          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">

              <input
                type="checkbox"
                name="wino"
                className="form-control"
                onChange={e => this.toggleCheckbox(e, 'alkohol', 'wino')}
                checked={this.state.alkohol.wino}
              />
            </div>
            <div className="col-sm-6">
              <label htmlFor="srednioprocentowe" style={labelStyle}>powyżej 4,5% do 18% zawartości alkoholu /z wyjątkiem piwa/</label>
            </div>
            <div className="col-sm-2" />
          </div>

          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-2" />
            <div className="col-sm-2">

              <input
                type="checkbox"
                name="wodka"
                className="form-control"
                checked={this.state.alkohol.wodka}
                onChange={e => this.toggleCheckbox(e, 'alkohol', 'wodka')} />
            </div>
            <div className="col-sm-6">
              <label htmlFor="srednioprocentowe" style={labelStyle}>powyżej 18% zawartości alkoholu</label>
            </div>
            <div className="col-sm-2" />
          </div>

        </GrayPanel>

        <GrayPanel title={'8. Rodzaj zezwolenia'}>
          {this.props.prefix !== 'hrubieszow' ?
            <div className="row mobile-row" style={rowStyle}>
              <div className="col-sm-2" />
              <div className="col-sm-2">
                <label htmlFor="niskoprocentowe" style={labelStyle}>Rodzaj zezwolenia</label>
              </div>
              <div className="col-sm-6">
                <Select
                  placeholder="Wybierz z listy..."
                  options={options}
                  value={this.state.alkohol.type}
                  onChange={(e) => this.onChange(e, 'alkohol')}
                  style={{
                    borderColor:
                      Object.keys(this.state.errors).indexOf('type') > -1 &&
                        this.state.errors.type !== null &&
                        this.state.errors.type.length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                  onBlur={event => event.preventDefault()}
                  optionClassName="needsclick"
                  blurInputOnSelect={false}
                />
                {Object.keys(this.state.errors).indexOf('type') > -1 &&
                  this.state.errors.type !== null &&
                  this.state.errors.type.length > 0 ?
                    <span
                      key={Object.keys(this.state.errors).indexOf('type')}
                      style={{
                        color: 'red',
                        fontSize: '10px',
                      }}
                    >
                      {this.state.errors.type}
                    </span> : null}
              </div>
              <div className="col-sm-2" />
            </div> : null}

          {this.state.alkohol.type === 'sklep' ?
            <div>
              <div className="row mobile-row" style={rowStyle}>
                <div className="col-sm-2" />
                <div className="col-sm-2">
                  <label htmlFor="niskoprocentowe" style={labelStyle}>Przedmiot działalności gospodarczej</label>
                </div>
                <div className="col-sm-6">
                  <Select
                    placeholder="Wybierz z listy..."
                    options={optionsPrzedmiot}
                    value={this.state.alkohol.przedmiot}
                    onChange={(e) => this.onChange(e, 'alkohol')}
                    style={{
                      borderColor:
                        Object.keys(this.state.errors).indexOf('przedmiot') > -1 &&
                          this.state.errors.przedmiot !== null &&
                          this.state.errors.przedmiot.length > 0
                          ? 'red'
                          : '#ccc',
                    }}
                    onBlur={event => event.preventDefault()}
                    optionClassName="needsclick"
                    blurInputOnSelect={false}
                  />
                  {Object.keys(this.state.errors).indexOf('przedmiot') > -1 &&
                    this.state.errors.przedmiot !== null &&
                    this.state.errors.przedmiot.length > 0 ?
                      <span
                        key={Object.keys(this.state.errors).indexOf('przedmiot')}
                        style={{
                          color: 'red',
                          fontSize: '10px',
                        }}
                      >
                        {this.state.errors.przedmiot}
                      </span> : null}
                </div>
                <div className="col-sm-2" />
              </div>

              <div className="row mobile-row" style={rowStyle}>
                <div className="col-sm-2" />
                <div className="col-sm-2">
                  <label htmlFor="niskoprocentowe" style={labelStyle}>Sprzedaż będzie prowadzona w punkcie (np. budynek wielorodzinny, usługowo-biurowy itp.)</label>
                </div>
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="punkt"
                    className="form-control"
                    onChange={e => this.onChange(e, 'alkohol')}
                    value={this.state.alkohol.punkt}
                  />
                </div>
                <div className="col-sm-2" />
              </div>
            </div> : null}
        </GrayPanel>

        {this.props.prefix === 'hrubieszow' ?
          <DecisionContainer
            title={'9. Informacje dodatkowe'}
            data={this.state.contact}
            errors={this.state.errors}
            formDict={contactDict}
            onChange={e => this.onChange(e, 'contact')}
          /> : null}

        {this.props.prefix === 'hrubieszow' ?
          <GrayPanel title={'Informacja dla wnioskodawcy'}>
            <div className="row">
              <div className="col-sm-12">
                <p>W przypadku wniosku o wydanie zezwolenia na sprzedaż napojów alkoholowych należy dołączyć załacznik:</p>
                <ul>
                  <li>Dokument potwierdzający tytuł prawny wnioskodawcy do lokalu stanowiącego punkt sprzedaży napojów alkoholowych</li>
                  <li>Zgodę właściciela, użytkownika, zarządcy lub administratora budynku, jeżeli punkt sprzedaży będzie zlokalizowany w budynku mieszkalnym wielorodzinnym</li>
                  <li>Decyzję właściwego państwowego inspektora sanitarnego o zatwierdzeniu zakładu, o której mowa w art. 65 ust. 1 pkt 2 ustawy z dnia 25 sierpnia 2006 r. o bezpieczeństwie żywności i żywienia</li>
                </ul>
              </div>
            </div>
          </GrayPanel> :
          <GrayPanel title={'Informacja dla wnioskodawcy'}>
            <div className="row">
              <div className="col-sm-12">
                <p>W przypadku wniosku o wydanie zezwolenia na sprzedaż napojów alkoholowych należy dołączyć załacznik:</p>
                <ul>
                  <li>Dokument potwierdzający tytuł prawny wnioskodawcy do lokalu stanowiącego punkt sprzedaży napojów alkoholowych</li>
                  <li>Zgodę właściciela, użytkownika, zarządcy lub administratora budynku, jeżeli punkt sprzedaży będzie zlokalizowany w budynku mieszkalnym wielorodzinnym</li>
                  <li>Decyzję właściwego państwowego inspektora sanitarnego o zatwierdzeniu zakładu, o której mowa w art. 65 ust. 1 pkt 2 ustawy z dnia 25 sierpnia 2006 r. o bezpieczeństwie żywności i żywienia (Dz. U. z 2015 r . poz. 594)</li>
                </ul>
              </div>
            </div>
          </GrayPanel>}

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZezwolenieAlkohol.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts,
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZezwolenieAlkohol),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZezwolenieAlkohol.js